export default __webpack_public_path__ + "static/media/icon_verified.7d432305.svg";